import _ from 'lodash';
import { Person } from './Person';

const settingsDefaults = {
  toggleOnSwipe   : true,
};

export class Member extends Person {

  static validators = [
    x => {
      if ( ! x.id ) return 'must have an id';
      if ( ! x.membershipId ) return 'must have a membershipId';
      if ( ! x.id.startsWith( x.membershipId + '.' ) ) {
        return 'id must be prefixed with membershipId';
      }
    },
  ];

  constructor( options={} ) {
    if ( _.isString( options ) ) options = { id : options };
    super( options );
  }

  setting( key, defaultValue ) {
    if ( _.has( this, [ 'settings', key ] ) ) {
      const val = _.get( this, [ 'settings', key ] );
      if ( ! _.isNil( val ) ) return val;
    }
    if ( ! _.isNil( defaultValue ) ) return defaultValue;
    return settingsDefaults[ key ];
  }

}
